import Layout from '@/components/feature/Layout';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoryShowcase from './components/CategoryShowcase';
import HotArticles from './components/HotArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { faqs } from '@/mocks/data';

export default function Home() {
  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '蜜桃在线',
    url: 'https://www.mitaozaixian.com',
    description: '蜜桃在线是您首选的在线娱乐平台，提供极速稳定的访问体验、丰富多样的内容资源与贴心的用户服务。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'service@mitaozaixian.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '蜜桃在线',
    url: 'https://www.mitaozaixian.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.mitaozaixian.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <Layout>
      <SEOHead
        title="蜜桃在线 - 官方入口·极速体验 | 蜜桃在线官网"
        description="蜜桃在线是您首选的在线娱乐平台，提供极速稳定的访问体验、丰富多样的内容资源与贴心的用户服务。立即访问蜜桃在线，享受流畅、安全、便捷的全新在线体验，随时随地轻松畅享。"
        keywords="蜜桃在线,蜜桃在线官网,蜜桃在线入口,蜜桃在线最新地址,蜜桃在线免费体验,蜜桃在线手机版"
        canonicalUrl="https://www.mitaozaixian.com/"
      />

      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>

      <HeroSection />
      <FeaturesSection />
      <CategoryShowcase />
      <HotArticles />
      <FAQSection />
      <CTASection />
    </Layout>
  );
}